import { useEffect, useState } from "react";
import type XlsxImportWorkBook from "utils/xlsxImportExport/XlsxImportWorkBook";
import type { ValidatedData } from "utils/xlsxImportExport/XlsxImportWorkBook";
import type { WorkSheetDefinition } from "utils/xlsxImportExport/XlsxImportWorkSheet";

export default function useValidatedData<
  TWorkSheetDefs extends WorkSheetDefinition,
>(xlsxImportWorkBook: XlsxImportWorkBook<TWorkSheetDefs> | null | undefined) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [validatedData, setValidatedData] =
    useState<ValidatedData<TWorkSheetDefs>>(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (xlsxImportWorkBook) {
      setIsProcessing(true);
      xlsxImportWorkBook
        .getValidatedData()
        .then((result) => setValidatedData(result))
        .catch(setError)
        .finally(() => setIsProcessing(false));
    }
  }, [xlsxImportWorkBook]);

  return { validatedData, error, isProcessing };
}
